export default class AlacakliBilgileri {
    alacakli_isim!:string|null;
    alacakli_ad!:string|null;
    alacakli_soyad!:string|null;
    alacakli_kurum_mu!:string|null;
    alacakli_tc_vergi !: number;
}